import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/wf/Header";
import { Hero } from "@/components/wf/Hero";
import { Services, WhoWeHelp, Tours, SignatureEvents, HowItWorks, Gallery } from "@/components/wf/Sections";
import { Contact } from "@/components/wf/Contact";
import { Footer } from "@/components/wf/Footer";
import { WhatsAppButton } from "@/components/wf/WhatsAppButton";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <main className="bg-brand-navy" data-testid="home-page">
      <Header />
      <Hero />
      <Services />
      <WhoWeHelp />
      <Tours />
      <SignatureEvents />
      <HowItWorks />
      <Gallery />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
